import { LuLeaf } from 'react-icons/lu'
import { Reveal } from '@/components/ui/Reveal'

export const BlogComingSoon = () => (
  <section className="bg-base-50 py-16 sm:py-20 lg:py-24">
    <div className="mx-auto max-w-3xl px-6">
      <Reveal>
        <div className="rounded-3xl border border-base-200 bg-white px-6 py-14 text-center sm:px-12">
          <span className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-green-50 text-green-700">
            <LuLeaf aria-hidden="true" className="h-6 w-6" />
          </span>
          <h2 className="font-display text-3xl leading-tight tracking-tight text-base-900 sm:text-4xl">
            Practical herbal knowledge is <span className="text-green-700">coming soon</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-base leading-7 text-base-600">
            Kandake is preparing thoughtful resources on herbal medicine, women's health, seasonal
            wellbeing, and nature connection. Join the mailing list to hear when the first articles
            are published.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
)
